import { Component, OnInit, inject } from '@angular/core'
import { EventTypes, LoginResponse, OidcSecurityService, PublicEventsService } from 'angular-auth-oidc-client'
import { AppSpinnerService } from './core/services/app-spinner.service'
import { UserInfoService } from './core/services/user-info.service'
import { MessageService } from 'primeng/api'
import { filter, take } from 'rxjs'
import { mountRouter } from './core/services/app-loader.service'
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    providers: [MessageService],
    standalone: false
})
export class AppComponent implements OnInit {
    oidcSecurityService = inject(OidcSecurityService);
    private appSpinnerService = inject(AppSpinnerService);
    private userInfoService = inject(UserInfoService);
    private eventService = inject(PublicEventsService);

    userLoaded = false
    configLoaded = false
    checkedLogin = false
    publicRoute = false

    get mountRouter() {
        return mountRouter.value
    }

    ngOnInit() {
        this.publicRoute = window.location.pathname.indexOf('users/confirmation') !== -1 ? true : false

        this.appSpinnerService.setSpinner(true)

        this.oidcSecurityService.checkAuth().subscribe((loginResponse: LoginResponse) => {
            this.configLoaded = true
            this.appSpinnerService.setSpinner(false)

            if (loginResponse.isAuthenticated && !this.publicRoute && loginResponse.userData) {
                this.checkedLogin = true
                this.loadUserInfo(loginResponse)
                this.userInfoService.startSessionCookieWatch()
            } else {
                const cookie = this.userInfoService.getCookieData()
                const value = this.userInfoService.getCookie(cookie.name)

                if (value === 'yes' && !loginResponse.errorMessage) {
                    this.oidcSecurityService.authorize()
                }

                if (value === '' && !loginResponse.isAuthenticated) {
                    mountRouter.next(true)
                }
            }

            // IdP check-session: optional fast path when the iframe reports a session change.
            // Cookie poll remains the reliable fallback (cross-origin check-session is often muted).
            this.eventService
                .registerForEvents()
                .pipe(
                    filter(notification => notification.type === EventTypes.CheckSessionReceived),
                    filter(event => event.value === 'changed'),
                    take(1)
                )
                .subscribe(() => {
                    mountRouter.next(false)
                    this.userInfoService.endSessionAndReauthenticate()
                })

            this.eventService
                .registerForEvents()
                .pipe(
                    filter(notification => notification.type === EventTypes.CheckSessionReceived),
                    take(1)
                )
                .subscribe(event => {
                    if (event.value == 'unchanged') {
                        setTimeout(() => {
                            mountRouter.next(true)
                        }, 500)
                    }
                })
        })
    }

    loadUserInfo(loginResponse) {
        this.appSpinnerService.setSpinner(true)
        this.userInfoService.loadUserInfo(loginResponse).subscribe({
            next: () => {
                this.appSpinnerService.setSpinner(false)
                this.userLoaded = true
            },
            error: error => {
                setTimeout(() => {
                    this.userInfoService.endSessionAndReauthenticate()
                }, 3000)
            },
        })
    }
}
